/**
 * Report-Definition für die Machbarkeit (Scope).
 *
 * Übersetzt den gespeicherten Datenstand der Machbarkeit-Seite in ein
 * {@link ReportDocument}. Analog zu {@link ./projektauftragReport}: deklariert
 * nur den Inhalt, der gemeinsame Renderer erzeugt das PDF.
 */
import {
  buildDocument,
  buildSection,
  textBlock,
  type ReportDocument,
} from '../../../lib/pdf/reportModel';

export interface MachbarkeitReportInput {
  // Machbarkeit (Scope)
  problem: string;
  scope: string;
  outOfScope: string;
  // Rahmen
  vorgaben: string;
  annahmen: string;
}

export function buildMachbarkeitReport(input: MachbarkeitReportInput): ReportDocument {
  return buildDocument([
    buildSection('Machbarkeit (Scope)', [
      textBlock('Vision', input.problem),
      textBlock('Scope / Projektumfang', input.scope),
      textBlock('Out of Scope', input.outOfScope),
    ]),
    buildSection('Vorgaben & Annahmen', [
      textBlock('Vorgaben / Restriktionen', input.vorgaben),
      textBlock('Annahmen', input.annahmen),
    ]),
  ]);
}
